export const MESSAGE_ROUTES = {
	LIST: "/messages",
	DM: "/messages/dm/:recipientId",
} as const;
